import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { AbcTextBoxComponent } from '@barthauer/abc/ui-components';
import { FilterOption, HeaderButton, SearchMode } from '../viewModels/layout.viewModel';

@Component({
    selector: 'opath-core-nav-header',
    templateUrl: './navHeader.component.html',
    styleUrls: ['./navHeader.component.scss'],
    standalone: false
})
export class NavHeaderComponent implements OnInit {
  @ViewChild('searchInput', { static: false }) searchInput: AbcTextBoxComponent;
  @Output() onbuttonStateChanged: EventEmitter<void> = new EventEmitter();

  @Input() title: string;
  @Input() buttons: HeaderButton[];
  @Input() justyButtons: 'start' | 'end' | 'space-between' = 'start';
  @Input() hideFilterPanel: boolean = false;
  @Input() disableFilterMode: boolean = false;
  @Input() height: number = 100;

  public filterOptions: FilterOption[];

  private _currentFilterOption: FilterOption | undefined;
  public get currentFilterOption(): FilterOption | undefined {
    return this._currentFilterOption;
  }

  public set currentFilterOption(filterOption: FilterOption) {
    this._currentFilterOption = filterOption;
    this.RaiseOnFilterOptionChanged(this._currentFilterOption);
  }

  @Output() onFilterOptionChanged = new EventEmitter<FilterOption>();
  @Output() onSearchTermChanged = new EventEmitter<string>();
  @Output() onButtonClick = new EventEmitter<number>();

  public res: ResourceSet = ResourceSet.Empty;
  constructor(private resourcesService: ResourceManagerService) {}

  async ngOnInit(): Promise<void> {
    this.res = await this.resourcesService.getResourceSet('abc-opath-core');
    this.filterOptions = this.getFilterOptions();
    this.currentFilterOption = this.filterOptions[0];
  }

  ngAfterViewInit(): void {
    this.searchInput?.instance.focus();
  }

  public getFilterOptions(): FilterOption[] {
    return [
      { searchMode: SearchMode.Contains, caption: this.res.get('searchMode-contains'), icon: 'contains' },
      { searchMode: SearchMode.Equals, caption: this.res.get('searchMode-equals'), icon: 'equal' },
      { searchMode: SearchMode.NotEqual, caption: this.res.get('searchMode-notEqual'), icon: 'notequal' },
      { searchMode: SearchMode.Greater, caption: this.res.get('searchMode-greater'), icon: 'greater' },
      {
        searchMode: SearchMode.GreaterOrEqual,
        caption: this.res.get('searchMode-greaterOrEqual'),
        icon: 'greaterorequal',
      },
      { searchMode: SearchMode.Less, caption: this.res.get('searchMode-less'), icon: 'less' },
      { searchMode: SearchMode.LessOrEqual, caption: this.res.get('searchMode-lessOrEqual'), icon: 'lessorequal' },
      { searchMode: SearchMode.NotContains, caption: this.res.get('searchMode-notContains'), icon: 'doesnotcontain' },
      { searchMode: SearchMode.StartsWith, caption: this.res.get('searchMode-startsWith'), icon: 'startswith' },
      { searchMode: SearchMode.EndsWith, caption: this.res.get('searchMode-endsWith'), icon: 'endswith' },
      { searchMode: SearchMode.IsLike, caption: this.res.get('searchMode-isLike'), icon: 'eyeopen' },
      { searchMode: SearchMode.NotLike, caption: this.res.get('searchMode-notLike'), icon: 'eyeclose' },
    ];
  }

  public filterOptionChanged(event: any) {
    this.currentFilterOption = event.itemData as FilterOption;
  }

  private RaiseOnFilterOptionChanged(filterOption: FilterOption): void {
    this.searchInput && this.onFilterOptionChanged.emit(filterOption);
  }

  public searchTermChanged(event: any) {
    this.onSearchTermChanged.emit(event.value);
  }

  public handlebuttonClick(button: HeaderButton) {
    button.action();
    this.onbuttonStateChanged.emit();
  }
}
